// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.codeWrapper, .codeWrapper code {
  background-color: black !important;
  color: white !important;
  text-shadow: none !important;
  border-radius: 10px !important;
  font-size: 13px !important;
}

.codeWrapper * {
  background-color: black !important;
}

.chat-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: inherit;
  background-position: inherit;
  background-repeat: inherit;
  background-size: inherit;
  opacity: 0.15;
  z-index: -1;
}


@keyframes pulsing2 {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
}

.pulsing2 {
  animation: pulsing2 1s infinite;
}

/* Hide scrollbar for all elements */
::-webkit-scrollbar {
  display: none;
}

/* For Firefox */
body {
  scrollbar-width: none;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  /*background-color: #282c34;*/
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  /*color: white;*/
}

.App-link {
  /*color: #61dafb;*/
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,aAAa;EACb,WAAW;AACb;;;AAGA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.codeWrapper, .codeWrapper code {\n  background-color: black !important;\n  color: white !important;\n  text-shadow: none !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n}\n\n.codeWrapper * {\n  background-color: black !important;\n}\n\n.chat-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: inherit;\n  background-position: inherit;\n  background-repeat: inherit;\n  background-size: inherit;\n  opacity: 0.15;\n  z-index: -1;\n}\n\n\n@keyframes pulsing2 {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n}\n\n.pulsing2 {\n  animation: pulsing2 1s infinite;\n}\n\n/* Hide scrollbar for all elements */\n::-webkit-scrollbar {\n  display: none;\n}\n\n/* For Firefox */\nbody {\n  scrollbar-width: none;\n}\n\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  /*background-color: #282c34;*/\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  /*color: white;*/\n}\n\n.App-link {\n  /*color: #61dafb;*/\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
